import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { ReportService } from '../report.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {

  username: string = '';
  loadIndicatorVisible: boolean;
  password: string = '';
  _username: string = '';
  _password: string = '';
  @Output() auth = new EventEmitter<any>();

  constructor(private service: ReportService) {
    
  }

  ngOnInit() {
  }

  onFormSubmit(e) {

    this.loadIndicatorVisible = true;
    this.service.login(this.username, this.password).subscribe(response => {
      this.loadIndicatorVisible = false;
      if(response.codigo == 1) {
        notify({
          message: "Bienvenido.",
          position: {
              my: "center top",
              at: "center top"
          }
        }, "success", 3000);
        this.auth.emit(response);
      } else {
        notify({
          message: "Usuario y/o contraseña invalido(s)",
          position: {
              my: "center top",
              at: "center top"
          }
        }, "error", 3000);
      }
    });
    /*if(this.username==this._username && this.password==this._password) {
      notify({
        message: "Bienvenido.",
        position: {
            my: "center top",
            at: "center top"
        }
      }, "success", 3000);
      this.auth.emit(true);
    } else {
      notify({
        message: "Usuario y/o contraseña invalido(s)",
        position: {
            my: "center top",
            at: "center top"
        }
      }, "error", 3000);
    }*/
    
    e.preventDefault();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/report/auth/auth.component.ts